import React, { useState, useEffect } from 'react';
import { NavLink, useParams } from 'react-router-dom';

import ImageSkeleton from '../../components/Skeleton/ImageSkeleton';
import TextSkeleton from '../../components/Skeleton/TextSkeleton';

import GascoIcoPlayAzul from '../../assets/images/ico-play-azul.svg';
import GascoEmisorPodcasting from '../../assets/images/logo-emisor-podcasting.svg';
import GascoIcoLink from '../../assets/images/ico-link.svg';
import GascoIcoTwitter from '../../assets/images/ico-twitter.svg';
import GascoIcoFacebook from '../../assets/images/ico-facebook.svg';

import { getPodcastBySlug, getOtrosPodcasts } from '../../config/services/strapi/strapi';

import { Podcast } from '../../interfaces/types';

import { formatearFechaLarga } from '../../helpers/fecha';
import AudioPlayer from '../../components/AudioPlayer/AudioPlayer';

function DetallePodcast() {
  const [cargando, setCargando] = useState({
    podcast: true,
    otrosPodcasts: true,
  });

  const [podcast, setPodcast] = useState<Podcast | null>(null);
  const [otrosPodcasts, setOtrosPodcasts] = useState<Podcast[]>([]);

  const { slug } = useParams<{ slug: string }>();

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    window.alert('Enlace copiado a su portapapeles');
  }

  const handleInit = () => {
    const fetchPodcast = async () => {
      setCargando(prev => ({ ...prev, podcast: true }));

      const rawPodcast = await getPodcastBySlug(slug as string);
      setPodcast({
        id: rawPodcast.id,
        titulo: rawPodcast.titulo,
        descripcion: rawPodcast.descripcion,
        fecha: rawPodcast.fecha,
        autor: rawPodcast.autor,
        exponentes: rawPodcast.exponente_podcasts,
        audioUrl: rawPodcast.audio.url,
        portadaUrl: rawPodcast.portada.url,
        slug: rawPodcast.slug
      });

      setCargando(prev => ({ ...prev, podcast: false }));

      document.title = `${rawPodcast.titulo} | Gasco Soluciones Energéticas`;
    };

    const fetchOtrosPodcasts = async () => {
      setCargando(prev => ({ ...prev, otrosPodcasts: true }));

      const rawOtrosPodcasts = await getOtrosPodcasts(slug as string);
      const mappedOtrosPodcasts = rawOtrosPodcasts.map((otroPodcast: any) => ({
        id: otroPodcast.id,
        titulo: otroPodcast.titulo,
        descripcion: otroPodcast.descripcion,
        fecha: otroPodcast.fecha,
        autor: otroPodcast.autor,
        exponentes: otroPodcast.exponentes || [],
        audioUrl: otroPodcast.audio.url,
        portadaUrl: otroPodcast.portada.url,
        slug: otroPodcast.slug
      }));

      setOtrosPodcasts(mappedOtrosPodcasts);
      setCargando(prev => ({ ...prev, otrosPodcasts: false }));
    };

    setPodcast(null);
    setOtrosPodcasts([]);

    fetchPodcast();
    fetchOtrosPodcasts();
  }

  useEffect(() => {
    handleInit();
  }, [slug]);

  return (
    <main>
      {/* Hero */}
      <section className='px-[15px] lg:px-36' style={{ background: 'linear-gradient(90deg, #00A1DC 0%, #54C2BF 100%)' }}>
        <div className="grid grid-cols-12 pb-12 gap-0 lg:gap-16 lg:pb-20 md:pt-6">
          {
            cargando.podcast ?

              <ImageSkeleton className="col-span-12 md:col-span-4 w-[280px] md:w-[340px] lg:w-[500px] h-[360px] rounded-xl overflow-hidden" /> 

              :

              <div className='px-[15px] lg:px-0 pt-18 md:pt-10 col-span-12 md:col-span-4'>
                <img src={podcast?.portadaUrl} alt="" className='w-[280px] md:w-[340px] lg:w-[500px] h-auto' />
              </div>
          }
          <div className="px-[15px] lg:px-0 col-span-12 md:col-span-8">
            <div className="mt-6">
              {
                cargando.podcast ?

                  <TextSkeleton className="!mb-[20px] !max-w-lg" />

                  :

                  <>
                    <time className='!text-[18px] !leading-[27px] !font-[400] !text-[rgb(221,221,221)] uppercase'>
                      {formatearFechaLarga(podcast?.fecha || '')}
                    </time>
                    <h1 className="my-0 md:!-mt-2 !text-[36px] !font-[700] !leading-[65px] !text-white">
                      {podcast?.titulo || 'Cargando...'}
                    </h1>
                    <div className='!text-[18px] !font-[400] !leading-[27px] text-[rgb(221,221,221)] mt-4'>
                      Por: <span className='!text-white uppercase font-[500]'>{podcast?.autor || 'Cargando...'}</span>
                    </div>
                  </>
              }
              <a href="#" className='!my-[25.5px] !py-[6.375px] pr-[12.75px] uppercase !text-white flex justify-start items-center gap-4 !text-[15px] font-semibold'>
                <img src={GascoIcoPlayAzul} alt="" className='inline-block mr-2' />
                Escúchalo ahora
              </a>
              <a href="https://www.emisorpodcasting.com/" className='!rounded-sm !bg-black !text-white text-[13px] font-medium !px-[15px] py-[12px] mb-14'>
                Escúchanos en:
                <img src={GascoEmisorPodcasting} alt="Emisor Podcasting" className='inline-block ml-4' />
              </a>
              <h4 className='!text-[20px] text-white pt-4'>Compartir</h4>
                <ul className='flex items-center gap-6 mt-2'>
                  <li>
                    <button onClick={handleCopyLink} className='text-white cursor-pointer'>
                      <img src={GascoIcoLink} alt="link" className='inline-block mr-2' />
                    </button>
                  </li>
                  <li>
                    <a href={`http://twitter.com/share?text=Energ%C3%ADa%20que%20transforma&url=${encodeURIComponent(window.location.href)}&hashtags=gasco,energia`} target='_blank' className='text-white'>
                      <img src={GascoIcoTwitter} alt="twitter" className='inline-block mr-2' />
                    </a>
                  </li>
                  <li>
                    <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`} target='_blank' className='text-white'>
                      <img src={GascoIcoFacebook} alt="facebook" className='inline-block mr-2' />
                    </a>
                  </li>
                </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Detalles Episodio */}
      <section className='px-[30px] lg:px-36 mt-10 pb-20 md:pb-12'>
        <div>
          {
            cargando.podcast ?

              <TextSkeleton className="!mb-[51px] max-w-xl" />

              :

              <p className='text-[var(--text-color-primary)] !text-[17px] 2xl:!text-[24px] !leading-[23.8px] 2xl:!leading-[33.6px]'>
                {podcast?.descripcion || 'Cargando...'}
              </p>
          }
        </div>
        <div className='mt-10'>
          <div className='w-full'>
            <h4 className='!text-[var(--text-color-primary)] !text-[22px] !leading-[26.4px] !font-[700]'>Exponentes de este episodio:</h4>
            <ul className="flex flex-col md:flex-row md:justify-start items-center mt-10 mb-3">
              {
                cargando.podcast ?

                  Array.from({ length: 3 }).map((_, index) => (
                    <li key={index} className='text-[var(--text-color-primary)] !text-[17px] !leading-[23.8px] flex flex-col justify-center items-center md:items-start mr-0 md:mr-[10%]'>
                      <ImageSkeleton className="w-[112px] h-[112px] rounded-full mb-3 overflow-hidden" />
                    </li>
                  ))

                  :
              
                  podcast?.exponentes.map((exponente) => (
                    <li key={exponente.id} className='text-[var(--text-color-primary)] !text-[17px] !leading-[23.8px] flex flex-col justify-start items-center md:items-start mr-0 md:mr-[10%]'>
                      <img
                        className='w-[112px] rounded-full !border-4 !border-[var(--border-color-secondary)] mb-3'
                        src={exponente.imagen.url}
                        alt={exponente.nombre}
                      />
                      <h5 className='!text-[var(--text-color-primary)] !text-[15px] !font-[700] !leading-[18px] !mt-[25.5px] !mb-[4.25px]'>{exponente.nombre}</h5>
                      <p className='!text-[var(--text-color-primary)] !text-[15px] !font-[400] !leading-[21px] mb-[17px]'>{exponente.cargo}</p>
                    </li>
                  ))
              }
            </ul>
          </div>
        </div>
      </section>
      {/* Otros episodios */}
      <section className='px-[18px] lg:px-36 mt-10 md:mt-0 pb-20'>
        {Boolean(otrosPodcasts.length) && <div className='my-10'>
          <h3 className='!text-[var(--text-color-primary)] !text-[36px] !font-[400] !leading-[43.2px]'>Más Episodios</h3>
        </div>}
        <div className="grid grid-cols-12 gap-4">
          {
            cargando.otrosPodcasts ?

              Array.from({ length: 3 }).map((_, index) => (
                <div key={index} className="col-span-12 flex justify-start items-start mb-6 gap-4">
                  <ImageSkeleton className="w-[200px] h-[200px] md:h-[150px] lg:h-[200px] rounded-xl overflow-hidden" />
                  <div className="flex justify-start items-center gap-x-2">
                    <TextSkeleton className="!mb-[20px]" />
                    <TextSkeleton className="!mb-[20px] invisible md:visible" />
                    <TextSkeleton className="!mb-[20px] invisible lg:visible" />
                    <TextSkeleton className="!mb-[20px] invisible xl:visible" />
                  </div>
                </div>
              ))

              :

              otrosPodcasts.map((otroPodcast: Podcast) => (
                <article key={otroPodcast.id} className="col-span-12 bg-[rgb(221,221,221)] px-[50px] pt-10 border-b">
                  <time className="!text-[var(--text-color-primary)] !text-[12px] !leading-[18px] !font-[400] uppercase mb-2">
                    {formatearFechaLarga(otroPodcast.fecha)}
                  </time>
                  <h4 className='!text-[var(--text-color-primary)] !text-[22px] !font-[700] !leading-[26.4px] !mt-[8.5px] !mb-[4.25px]'>
                    {otroPodcast.titulo}
                  </h4>
                  <address className='!text-[var(--text-color-secondary)] !text-[12px] !font-[400] !leading-[21px] mb-[17px] uppercase !decoration-none !not-italic'>
                    <span className='!text-[var(--text-color-primary)] !normal-case me-1'>Por:</span>
                    {otroPodcast.autor}
                  </address>
                  <p className='!text-[var(--text-color-primary)] !text-[15px] !font-[400] !leading-[30px] mb-[17px]'>
                    {otroPodcast.descripcion}
                  </p>
                  <NavLink to={`/podcast/${otroPodcast.slug}`} className='!my-[25.5px] !py-[6.375px] pr-[12.75px] uppercase !text-[var(--text-color-primary)] flex justify-start items-center gap-2 !text-[15px] font-semibold' replace>
                    <img src={GascoIcoPlayAzul} alt="" className='inline-block mr-2' />
                    Escúchalo ahora
                  </NavLink>
                </article>
              ))
          }
        </div>
      </section>
      <section className='fixed bottom-0 left-0 w-full h-[49.906px] md:h-[140px] z-[99]'>
        {Boolean(podcast) && <AudioPlayer audioUrl={podcast?.audioUrl || ''} audioTitle={podcast?.titulo || ''} />}
      </section>
    </main>
  )
}

export default DetallePodcast